var map = {
	"./3ddata.svg": 172,
	"./3djobs.svg": 173,
	"./3dmaintenance.svg": 174,
	"./3dpaas.svg": 175,
	"./Analytics.svg": 176,
	"./account.svg": 177,
	"./admin.svg": 178,
	"./anacreon.svg": 179,
	"./area51.svg": 180,
	"./autoflow.svg": 181,
	"./blacksea-portal.svg": 182,
	"./box.svg": 183,
	"./color-config.svg": 184,
	"./composer.svg": 185,
	"./da-vinci.svg": 186,
	"./devices.svg": 187,
	"./di.svg": 188,
	"./dscoop.svg": 189,
	"./go3d.svg": 190,
	"./home.svg": 191,
	"./imposer.svg": 192,
	"./indigo-events.svg": 193,
	"./jobs.svg": 194,
	"./jobs_2.svg": 195,
	"./knowledge-zone.svg": 196,
	"./lkc.svg": 197,
	"./locr-maps.svg": 198,
	"./market-admin.svg": 199,
	"./marketplace.svg": 200,
	"./media-locator.svg": 201,
	"./myknowledge.svg": 202,
	"./packzalyzer.svg": 203,
	"./pc-reporter.svg": 204,
	"./ppc.svg": 205,
	"./press-security.svg": 206,
	"./print-beat.svg": 207,
	"./pwicfa.svg": 208,
	"./ready2print.svg": 209,
	"./reseller_portal.svg": 210,
	"./resource-manager.svg": 211,
	"./service-calls.svg": 212,
	"./sim.svg": 213,
	"./site-flow.svg": 214,
	"./softproof.svg": 215,
	"./substrate-manager.svg": 216,
	"./supplies_and_parts.svg": 217,
	"./university.svg": 218,
	"./valid3d.svg": 219,
	"./wallart.svg": 220
};
function webpackContext(req) {
	return __webpack_require__(webpackContextResolve(req));
};
function webpackContextResolve(req) {
	return map[req] || (function() { throw new Error("Cannot find module '" + req + "'.") }());
};
webpackContext.keys = function webpackContextKeys() {
	return Object.keys(map);
};
webpackContext.resolve = webpackContextResolve;
module.exports = webpackContext;
webpackContext.id = 84;



//////////////////
// WEBPACK FOOTER
// ../~/@printos/gazelle/src/mini-apps/app-switcher/icons ../~/html-loader!\.svg$
// module id = 84
// module chunks = 0